module.exports = __webpack_public_path__ + "static/media/MacPortrait2w990@2x.1333bf88.webp";